import { render, staticRenderFns } from "./indxex.vue?vue&type=template&id=66741b7a&scoped=true"
import script from "./indxex.vue?vue&type=script&lang=js"
export * from "./indxex.vue?vue&type=script&lang=js"
import style0 from "./indxex.vue?vue&type=style&index=0&id=66741b7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66741b7a",
  null
  
)

export default component.exports